"use client";

import { useState } from "react";
import { speakers, speakerTemas, type SpeakerTema } from "@/lib/content";
import { SpeakerCard } from "@/components/speaker-card";

type TemaFilter = SpeakerTema | "Todos";

/** Filtro por tema + grilla completa de oradores. */
export function SpeakersDayGrid() {
  const [tema, setTema] = useState<TemaFilter>("Todos");

  const filtered = speakers.filter(
    (s) => tema === "Todos" || s.tema === tema,
  );

  return (
    <>
      {/* Barra de filtros */}
      <div className="flex flex-wrap items-center justify-between gap-x-8 gap-y-5 mb-12">
        {/* Filtro de tema */}
        <div className="relative">
          <label className="sr-only" htmlFor="tema-filter">
            Filtrar por tema
          </label>
          <select
            id="tema-filter"
            value={tema}
            onChange={(e) => setTema(e.target.value as TemaFilter)}
            className="appearance-none cursor-pointer rounded-full border border-white/35 bg-transparent text-white font-[family-name:var(--font-body)] text-base font-medium pl-6 pr-12 py-2.5 outline-none transition-colors hover:border-white/70 focus:border-white [&>option]:text-ink"
          >
            <option value="Todos">Todos los temas</option>
            {speakerTemas.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
          <svg
            aria-hidden
            viewBox="0 0 20 20"
            className="pointer-events-none absolute right-5 top-1/2 -translate-y-1/2 h-4 w-4 text-white/70"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
          >
            <path d="M6 8l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        {/* Conteo de oradores */}
        <span className="font-[family-name:var(--font-body)] text-sm text-white/50">
          {filtered.length} {filtered.length === 1 ? "orador" : "oradores"}
        </span>
      </div>

      {/* Grilla filtrada */}
      {filtered.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {filtered.map((s, i) => (
            <SpeakerCard key={i} speaker={s} />
          ))}
        </div>
      ) : (
        <p className="font-[family-name:var(--font-body)] text-white/60 py-12">
          No hay oradores para este tema.
        </p>
      )}
    </>
  );
}
